import { z } from "zod";
const attributesDetailSchema = z.object({
  title: z.string().optional(),
  icon: z.string().optional(),
  interactivity: z.string().optional(),
  open: z.boolean().optional()
});
export {
  attributesDetailSchema
};
//# sourceMappingURL=attributes.js.map
